import { Button } from '@/shared/ui/Button';
import type { FotoCapturaDTO } from '@/features/captura/tipos';
import { IconCamera } from '@/features/captura/components/icones';
import '@/features/captura/captura.css';

type Props = {
  fotos: FotoCapturaDTO[];
  aoTirarFotos: () => void;
  desabilitado?: boolean;
  /** Por que está desabilitado (ex.: "Requer internet"). */
  motivo?: string;
};

/**
 * Nova O.S.: as fotos tiradas pelo celular antes de salvar. Ficam na
 * sessão de captura e são vinculadas à O.S. quando ela é salva.
 */
export function FaixaFotosCaptura({ fotos, aoTirarFotos, desabilitado, motivo }: Props) {
  const n = fotos.length;
  return (
    <div className="card">
      <div className="card__header captura-card__header">
        <span className="card__title captura-card__titulo">
          {n > 0 ? `Fotos recebidas do celular (${n})` : 'Fotos do veículo'}
        </span>
        <Button onClick={aoTirarFotos} disabled={desabilitado} title={desabilitado ? motivo : undefined}>
          <IconCamera />
          {n > 0 ? 'Tirar mais fotos' : 'Tirar fotos pelo celular'}
        </Button>
      </div>
      <div className="card__body captura-faixa">
        <p className="captura-faixa__texto">
          {n > 0
            ? 'Elas entram nesta ordem de serviço quando você salvar.'
            : 'Opcional. Fotografe o veículo na entrada pelo celular — as fotos entram nesta ordem de serviço ao salvar.'}
          {desabilitado && motivo ? ` ${motivo}.` : ''}
        </p>
        {n > 0 && (
          <ul className="captura-faixa__miniaturas" aria-label="Fotos recebidas do celular">
            {fotos.map((f) => (
              <li key={f.id}>
                <img
                  src={f.url}
                  alt={f.areaRotulo}
                  title={f.areaRotulo}
                  loading="lazy"
                  decoding="async"
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
